import { render } from "./bNeoTopHolder.vue?vue&type=template&id=1024ec45"
import script from "./bNeoTopHolder.vue?vue&type=script&lang=js"
export * from "./bNeoTopHolder.vue?vue&type=script&lang=js"

import "./bNeoTopHolder.vue?vue&type=style&index=0&id=1024ec45&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__